export const TEAM_MEMBER_ACTION = {
  ALLOW: 'allow',
} as const;
